import * as bootstrap from '~bootstrap';

const DEFAULT_TOAST_DELAY = 5000;

// Escape HTML to prevent injection in toast content
export function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function mkToast(id, bsc, title, body, timeout) {
  let delay = parseInt(timeout, 10);
  if (isNaN(delay) || delay < 0) {
        delay = DEFAULT_TOAST_DELAY;
  }
  // Check if a toast wrapper already exists
  var toastWrapper = document.querySelector('.toast-container');
  
  // If not, create one and append to the body
  if(!toastWrapper) {
	toastWrapper = document.createElement('div');
	toastWrapper.classList.add('toast-container', 'm-3', 'bottom-0', 'end-0');
	document.body.appendChild(toastWrapper);
  }
  
  // Create a new toast inside the wrapper
  var toast = document.createElement('div');
  toast.id = id + '-toast';
  toast.classList.add('toast', 'bg-' + bsc, 'text-white');
  toast.role = 'alert';
  toast.ariaLive = 'assertive';
  toast.ariaAtomic = true;
  
  var toastHTML = `
        <div class="toast-header">
          <strong class="me-auto">` + escapeHtml(title) + `</strong>
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div id="` + id + `-toast-body" class="toast-body">` + escapeHtml(body) + `</div>
  `;
  
  toast.innerHTML = toastHTML;
  
  // Append the toast to the toast wrapper
  toastWrapper.appendChild(toast);
  
  // Initialize the Bootstrap Toast
  var errorToast = new bootstrap.Toast(toast, {autohide: true, delay});
  errorToast.show();
  
  // Remove the toast from the DOM after it has been hidden
  setTimeout(() => {
	errorToast.hide();
	toastWrapper.removeChild(toast);
	
	// Remove the wrapper if there are no more toasts
	if(toastWrapper.childNodes.length === 0) {
	  document.body.removeChild(toastWrapper);
	}
  }, delay);
}
